import React from 'react';
import c from '../w.js';

const IconChf = React.memo(
  c(
    /* @__PURE__ */ React.createElement("path", { d: "M8.01773 19.0001H10.3892V16.9802H12.2557V15.5164H10.3892V13.439H15.8288V11.4511H10.3892V7.89711H16.4041V5.90918H8.01773V15.5164H6.13208V16.9802H8.01773V19.0001Z" })
  )
);

export { IconChf };
